<div id="role" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent" fxLayout="row" fxLayoutAlign="space-between center">

            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">

                <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/role'">
                    <mat-icon>{{'arrow_back' | translate}}</mat-icon>
                </button>


                <div fxLayout="column" fxLayoutAlign="start start"
                    [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    <div class="h2" *ngIf="pageType ==='edit'">
                        <!-- {{tenunt.name}} -->
                    </div>
                    <div class="h2" *ngIf="pageType ==='new'">
                        {{'ROLE_ENTRY.newRole' | translate}}
                    </div>
                    <div class="subtitle secondary-text">
                        <span> {{'ROLE_ENTRY.roleDetail' | translate}}</span>
                    </div>
                </div>
            </div>
            <!-- / APP TITLE -->
            <!-- [disabled]="roleForm.invalid" -->
            <div class="button-container">
                <mat-spinner *ngIf="isLoading" strokeWidth="2" [diameter]="25"></mat-spinner>
                <button mat-raised-button class="save-role-button" [disabled]="roleForm.status == 'INVALID' || isLoading"
                    *ngIf="pageType ==='new'" (click)="addRole()">
                    <span>{{'ROLE_ENTRY.add' | translate}}</span>
                </button>

                <button mat-raised-button class="save-role-button"
                    [disabled]="(roleForm.status == 'INVALID' && roleForm.pristine) || isLoading" *ngIf="pageType ==='edit'"
                    (click)="saveRole()">
                    <span>{{'ROLE_ENTRY.save' | translate}}</span>
                </button>
            </div>
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT -->
            <div class="content p-24">

                <form name="roleForm" [formGroup]="roleForm" class="role w-100-p" fxLayout="column" >
                    <div class="tab-content" fusePerfectScrollbar>
                        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                            <mat-label>{{'ROLE_ENTRY.roleName' | translate}}</mat-label>
                            <input matInput placeholder="{{'ROLE_ENTRY.roleName' | translate}}" name="name"
                                formControlName="name" required>
                        </mat-form-field>

                    </div>

                 

                </form>
            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>